import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQrDesigns } from "../../redux/actions/qrDesignActions";
import { DashboardLayout } from "../dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaImage, FaEye, FaCalendarAlt } from "react-icons/fa";
import SearchBar from "../Components/SearchBar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import axiosInstance from "../../api/axiosInstance";
const QRDesignList = () => {
  const dispatch = useDispatch();
  const { loading, qr_designs, error, count } = useSelector((state) => state.qrDesign);
  const { userInfo } = useSelector((state) => state.auth);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filterStatus, setFilterStatus] = useState("all"); // all, active, inactive
  const navigate = useNavigate();
  const BASE_URL = axiosInstance.defaults.baseURL;
  const { access_modules } = useSelector((state) => state.dealerAccess);
  const qrPerms = access_modules?.data?.find((m) => m.alias === "qr_design");
  const canCreate = !!qrPerms?.is_create;
  const canRead = !!qrPerms?.is_read;

  useEffect(() => {
    if (userInfo?.access_token) {
      const filters = {};
      if (userInfo?.user_id) {
        filters.client_id = userInfo.user_id;
      }
      if (filterStatus !== "all") {
        filters.is_active = filterStatus === "active";
      }
      dispatch(getQrDesigns(filters, userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token, userInfo?.user_id, filterStatus]);

  if (error && !qr_designs.length) {
    return (
      <DashboardLayout>
        <div className="p-4">
          <p className="text-red-600">Error: {error}</p>
        </div>
      </DashboardLayout>
    );
  }
if (!canRead && access_modules?.data) {
  return (
    <DashboardLayout>
      <div className="text-center py-20">
        <p className="text-red-500 font-bold text-lg">Access Denied</p>
        <p className="text-gray-500 text-sm mt-2">You don't have permission to view QR Designs.</p>
      </div>
    </DashboardLayout>
  );
}
  const designArray = Array.isArray(qr_designs) ? qr_designs : [];

  const filteredDesigns = designArray
    .filter((design) => {
      const search = searchValue.toLowerCase();
      const clientName = design.client_name?.toLowerCase() || "";
      return clientName.includes(search);
    })
    .filter((design) => {
      if (!startDate && !endDate) return true;

      if (!design.created_at) return false;

      const createdDate = dayjs(design.created_at);
      if (!createdDate.isValid()) return false;

      const start = startDate ? dayjs(startDate).startOf("day") : null;
      const end = endDate ? dayjs(endDate).endOf("day") : null;

      if (start && createdDate.isBefore(start)) return false;
      if (end && createdDate.isAfter(end)) return false;

      return true;
    })
    .filter((design) => {
      if (filterStatus === "all") return true;
      return design.is_active === (filterStatus === "active");
    });

  return (
    <DashboardLayout>
      <div className="p-4 sm:p-6 lg:p-8">
        <div className="mb-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
            <h2 className="text-2xl font-bold text-amber-600 mb-1">
              QR Design Management
            </h2>
           {canCreate && (
  <button
    onClick={() => navigate("/dashboard/createqrdesign")}
    className="flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 py-2 rounded-lg hover:from-amber-600 hover:to-amber-700 font-semibold transition-all duration-200 shadow-md hover:shadow-lg"
  >
    <FaPlus className="w-4 h-4" />
    <span>Create QR Design</span>
  </button>
)}
          </div>

          <div className="flex flex-col lg:flex-row gap-4 mb-4">
            <div className="flex-1">
              <SearchBar
                value={searchValue}
                onChange={setSearchValue}
                placeholder="Search by client name"
              />

            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                isClearable={true}
                placeholderText="Select date range"
                className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500 text-sm"
              />
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500 text-sm"
              >
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
            <p className="mt-2 text-gray-600">Loading QR designs...</p>
          </div>
        ) : filteredDesigns.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg shadow-sm">
            <FaImage className="mx-auto text-gray-400 text-5xl mb-4" />
            <p className="text-gray-600 text-lg">No QR designs found</p>
            <p className="text-gray-500 text-sm mt-2">
              {searchValue || filterStatus !== "all" || (startDate || endDate)
                ? "Try adjusting your filters"
                : "Create your first QR design to get started"}
            </p>
          </div>
        ) : (
          // <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          //   {filteredDesigns.map((design) => (
          //     <div
          //       key={design.id}
          //       className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow overflow-hidden"
          //     >
          //       <div className="relative h-48 bg-gray-200">
          //         {design.qr_image ? (
          //           <img
          //             src={design.qr_image}
          //             alt="QR Design"
          //             className="w-full h-full object-cover"
          //             onError={(e) => {
          //               e.target.src = "https://via.placeholder.com/400x200?text=Image+Not+Available";
          //             }}
          //           />
          //         ) : (
          //           <div className="w-full h-full flex items-center justify-center bg-gray-100">
          //             <FaImage className="text-gray-400 text-4xl" />
          //           </div>
          //         )}
          //         <div className="absolute top-2 right-2">
          //           <span
          //             className={`px-2 py-1 rounded text-xs font-semibold ${design.is_active
          //                 ? "bg-green-500 text-white"
          //                 : "bg-gray-500 text-white"
          //               }`}
          //           >
          //             {design.is_active ? "Active" : "Inactive"}
          //           </span>
          //         </div>
          //       </div>
          //       <div className="p-4">
          //         <div className="space-y-2 text-sm text-gray-600">
          //           <div className="flex items-center gap-2">
          //             <span className="font-medium">Client:</span>
          //             <span>{design.client_name || "N/A"}</span>
          //           </div>
          //           <div className="grid grid-cols-2 gap-2 text-xs">
          //             <div>
          //               <span className="font-medium">Bottom:</span> {design.bottom_percent || "0"}%
          //             </div>
          //             <div>
          //               <span className="font-medium">Right:</span> {design.right_percent || "0"}%
          //             </div>
          //             <div>
          //               <span className="font-medium">Rotation:</span> {design.rotation_percent || "0"}°
          //             </div>
          //             <div>
          //               <span className="font-medium">Size:</span> {design.qr_size_percent || "0"}%
          //             </div>
          //           </div>
          //           {design.created_at && (
          //             <div className="flex items-center gap-2 text-xs text-gray-500">
          //               <FaCalendarAlt className="text-gray-400" />
          //               <span>Created: {dayjs(design.created_at).format("DD MMM YYYY")}</span>
          //             </div>
          //           )}
          //         </div>
          //         <div className="mt-4 pt-4 border-t border-gray-200">
          //           <button
          //             onClick={() => window.open(design.qr_image, "_blank")}
          //             className="flex items-center gap-2 text-amber-600 hover:text-amber-700 font-medium text-sm"
          //           >
          //             <FaEye className="w-4 h-4" />
          //             <span>View Image</span>
          //           </button>
          //         </div>
          //       </div>
          //     </div>
          //   ))}
          // </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  {filteredDesigns.map((design) => {
    //  const imageUrl = `${BASE_URL}${design.qr_image.startsWith("/") ? design.qr_image.slice(1) : design.qr_image}`;
  
    const imageUrl = `${design.qr_image.startsWith("/") ? design.qr_image.slice(1) : design.qr_image}`;
  
    console.log("Image URLL",imageUrl)
      return (
      <div
        key={design.id}
        className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow overflow-hidden"
      >
        <div className="relative h-48 bg-gray-200">
          {design.qr_image ? (
            <img
              src={imageUrl}
              alt="QR Design"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400x200?text=Image+Not+Available";
              }}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-100">
              <FaImage className="text-gray-400 text-4xl" />
            </div>
          )}
          <div className="absolute top-2 right-2">
            <span
              className={`px-2 py-1 rounded text-xs font-semibold ${
                design.is_active
                  ? "bg-green-500 text-white"
                  : "bg-gray-500 text-white"
              }`}
            >
              {design.is_active ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
        <div className="p-4">
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <span className="font-medium">Client:</span>
              <span>{design.client_name || "N/A"}</span>
            </div>
            <div className="grid grid-cols-2 gap-2 text-xs">
              <div>
                <span className="font-medium">Bottom:</span> {design.bottom_percent || "0"}%
              </div>
              <div>
                <span className="font-medium">Right:</span> {design.right_percent || "0"}%
              </div>
              <div>
                <span className="font-medium">Rotation:</span> {design.rotation_percent || "0"}°
              </div>
              <div>
                <span className="font-medium">Size:</span> {design.qr_size_percent || "0"}%
              </div>
            </div>
            {design.created_at && (
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <FaCalendarAlt className="text-gray-400" />
                <span>Created: {dayjs(design.created_at).format("DD MMM YYYY")}</span>
              </div>
            )}
          </div>
          <div className="mt-4 pt-4 border-t border-gray-200">
            <button
              onClick={() => window.open(imageUrl, "_blank")}
              className="flex items-center gap-2 text-amber-600 hover:text-amber-700 font-medium text-sm"
            >
              <FaEye className="w-4 h-4" />
              <span>View Image</span>
            </button>
          </div>
        </div>
      </div>
    );
  })}
</div>
        )}

        {!loading && filteredDesigns.length > 0 && (
          <div className="mt-6 text-center text-gray-600 text-sm">
            Showing {filteredDesigns.length} of {count} QR design(s)
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default QRDesignList;

